import { DummyReelSymbol, ReelInit, ReelObject } from "./ReelInit";

import { Group /*, Easing*/, Tween } from "tweedle.js";
import { getSymbol /*, isLandingAnimationExist*/ } from "../config/getSymbol";
import { GameConstants } from '../gameClientEvents/GameConstants';

import { Spine } from '@esotericsoftware/spine-pixi-v8';
import { currentBackgorundMusic, currentBackgorundMusicVolume, isQuickBtnOnGlobal, isSlamClickedGlobal, isSuperQuickBtnOnGlobal, RespinIndex, setIsSlamClickedGlobal } from "../config/GlobalVariableConfig";
import {
    REEL_NUMBERS,
    setVisibleSymbols,
    SYMBOL_HEIGHT,
    SYMBOLS_PER_REEL
} from "../config/reelConfig";
// import { GSAPScreenShake } from "../core/GSAPScreenShake";
import { spinData } from "../server/getServerResposesFun";

// import { Event, TrackEntry } from "@esotericsoftware/spine-pixi-v8";
import { IMediaInstance, sound } from "@pixi/sound";
import { Manager } from "../core/Manager";

const reelTweenGroup = new Group();

// const POS_MOVE_TIME = 150;



export class ReelSpin extends ReelInit {

    // private spinData: SpinDataObject;


    public running = false;
    public isBetDecline = false;

    // private normalReelPlayStarted = false;
    // private slamClicked = false;


    private anticipationReels: number[];
    private wildAnticipationReels: number[];
    private movingSteps: number[];

    // private anticipationSounds: any[] = []; // Array to keep track of sound instances

    private reelSounds: (IMediaInstance | null)[] = [];

    private anticipationInSound: IMediaInstance | null = null;
    private anticipationLoopSound: IMediaInstance | null = null;

    private resetBackgoundVolume: boolean = false


    constructor() {
        super();

        this.movingSteps = [];

        this.setReelSpinSound();
        this.anticipationReels = [];
        this.wildAnticipationReels = [];

    }


    private setReelSpinSound(): void {
        this.reelSounds = new Array(REEL_NUMBERS).fill(null);
    }

    private playReelSound(reelIndex: number): void {
        if (reelIndex < 0 || reelIndex >= REEL_NUMBERS) return;

        // Stop old instance if exists
        this.reelSounds[reelIndex]?.stop();

        this.reelSounds[reelIndex] = sound.play('reels_spinning', {
            loop: true,
            volume: 0.5 / REEL_NUMBERS,
        }) as IMediaInstance;
    }

    private stopReelSound(reelIndex: number): void {
        if (reelIndex < 0 || reelIndex >= REEL_NUMBERS) return;

        this.reelSounds[reelIndex]?.stop();
        this.reelSounds[reelIndex] = null;
    }

    private stopAllReelSounds(): void {
        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.stopReelSound(i);
        }
    }

    public updateReelSpin(): void {

        Group.shared.update();
        reelTweenGroup.update();

        if (isSlamClickedGlobal) {
            this.stopAnticipation();
        }

    }


    // private isMouseMeterActivated: boolean = false;
    private ismovingReelStepsCounted: boolean = false;

    public async startReels(RespinIndex: number, isNewSpin: boolean, spinStype: string): Promise<void> {
        try {

            console.log(`startReels this.running ${this.running}`);

            // if (this.running) {
            //     return;
            // }

            // this.spinStype = spinStype;

            this.running = true;
            this.ismovingReelStepsCounted = false;
            this.resetBackgoundVolume = false;

            this.isBetDecline = false;
            setIsSlamClickedGlobal(false);

            // this.slamClicked = false;
            // this.quickStop = this.ui.burgerMenuObj.isTurboBtnOn;


            // make container's symbols visible before spinning
            for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
                this.setReelSpinContentVisibility(this.allReelArray[reelNum].container, true);
            }



            if (isNewSpin) {
                this.resetReelOverlayContainer();
                // this.isMouseMeterActivated = false;
            }


            /****  actual reel play ***************************** */


            await this.reelSpinFun(RespinIndex, isNewSpin, spinStype);

        } catch (error: any) {
            console.log("inside catch of startPlay");
            throw (error);
        }

    }

    private getMovingSteps(RespinIndex: number, isNewSpin: boolean) {

        console.log("inside getMovingSteps");

        if (!isNewSpin) {
            this.movingSteps = [1, 1, 1, 1, 1];
            return;
        }

        let scatterAppear: number[] = [];
        let silverWildAppear: number[] = [];
        spinData.respins[RespinIndex].reelSymbols.forEach(row => {
            let appearFlag = row.find(pos => pos === 12) ? 1 : 0;  // 12 is the scatter id
            scatterAppear.push(appearFlag);

            let silverAppearFlag = row.includes(GameConstants.SILVER_WILD_SYMOL_ID) ? 1 : 0;
            silverWildAppear.push(silverAppearFlag);
        });


        const anticipationAfterGetting = 2;
        let scatterExist: number[] = [0, 1, 1, 1, 0]; // scatter appear on reels
        let ancipation: number[] = [];
        this.wildAnticipationReels = [];

        let sum = 0;
        scatterAppear.forEach((val, i) => {
            sum += val;

            if (sum - val >= anticipationAfterGetting && scatterExist[i] == 1) {
                ancipation.push(1);
            }
            else {
                ancipation.push(0);
            }

        })

        // console.log("ancipation", ancipation);
        this.anticipationReels = ancipation;

        // this.movingSteps = [1, 2, 3, 4, 5];
        if (silverWildAppear[0] === 1) {
            this.movingSteps = [1, 50, 55, 60, 95];
            let additionalSteps = 0;
            for (let i = 0; i < this.movingSteps.length; i++) {
                if (ancipation[i] === 1) {
                    if (!spinData.isBuyFeatureActive) {
                        additionalSteps += 45;
                    }
                }
                this.movingSteps[i] += additionalSteps; // Add 10 to movingSteps at index i
            }

            this.wildAnticipationReels = [0, 0, 0, 0, 1];
        } else {
            this.movingSteps = [1, 5, 10, 15, 20];
            let additionalSteps = 0;
            for (let i = 0; i < this.movingSteps.length; i++) {
                if (ancipation[i] === 1) {
                    if (!spinData.isBuyFeatureActive) {
                        additionalSteps += 45;
                    }
                }
                this.movingSteps[i] += additionalSteps; // Add 10 to movingSteps at index i
            }
        }

        // (initData.spinTime >= 5000 && this.spinStype === "BASE") ?
        //     [1, 3, 5, 7, 9]
        //     :
        //     [1, 2, 3, 4, 5]
        // ;

        // this.movingSteps = [1, 5, 9, 13, 17];//[1, 2, 3, 4, 5];




        console.log("this.movingSteps", this.movingSteps);
        // return ancipation;

        // return [0, 0, 0, 0, 0]

    }

    private async landingAnimation(reelNum: number): Promise<void> {

        const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

        const animationPromises: Promise<void>[] = [];

        let scatterLanded = false;
        for (let j = 0; j < SYMBOLS_PER_REEL[reelNum]; j++) {

            const posNum = j;

            const symbol = this.reelSymbols[reelNum][posNum];

            const symbolId = this.allReelArray[reelNum].symbols[posNum].id;

            if (symbolId == 12) {
                scatterLanded = true;
            }

            let animationPromise: Promise<void>;

            if (symbolId === GameConstants.SILVER_WILD_SYMOL_ID || symbolId === GameConstants.GOLDEN_WILD_SYMOL_ID) {
                animationPromise = this.playWildLandingAnim(symbol, reelNum, j, symbolId);
                if (symbolId === GameConstants.SILVER_WILD_SYMOL_ID) {
                    sound.play('wild_land', { volume: 0.5, speed: timeScale })
                }

            } else {
                animationPromise = new Promise<void>((resolve) => {
                    let listener = {
                        complete: () => {
                            resolve();
                            symbol.state.removeListener(listener);
                        }
                    };
                    symbol.state.addListener(listener);

                    symbol.state.setAnimation(0, "land", false);
                    symbol.state.timeScale = timeScale;
                })
            }

            animationPromises.push(animationPromise);
        }


        if (scatterLanded) {
            sound.play('scatter_land', { volume: 1, speed: timeScale });
        }
        else {
            sound.play('reel_stop', { volume: 1, speed: timeScale });
        }

        await Promise.all(animationPromises);
        this.stopAnticipationSound();
    }

    private playWildLandingAnim(symbol: Spine, reelNum: number, idx: number, symbolId: number): Promise<void> {
        const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
        const fData = spinData.respins[RespinIndex.value].featureData.nudgeInfo;
        let idxWild = (fData.length > 1 && symbolId === GameConstants.GOLDEN_WILD_SYMOL_ID) ? 1 : 0;
        let animationPromise;
        if (fData && fData.length > 0 && fData[idxWild].reelNum === reelNum) {
            if (idx === fData[idxWild].posNum) {
                animationPromise = new Promise<void>((resolve) => {
                    let listener = {
                        complete: (entry: any) => {
                            if (entry.animation.name.startsWith("land")) {
                                if (!isSuperQuickBtnOnGlobal && !isQuickBtnOnGlobal && !isSlamClickedGlobal) {
                                    this.animateMask(spinData.respins[RespinIndex.value].featureData.reelHeightPerReel);
                                }
                            }
                        },
                        start: (entry: any) => {
                            if (entry.animation.name.startsWith("idle")) {
                                this.hideSymbols(fData[idxWild].reelNum, fData[idxWild].posNum, fData[idxWild].dir);
                                // GSAPScreenShake.stop();
                                resolve();
                                symbol.state.removeListener(listener);
                            }
                        }
                    };

                    symbol.state.addListener(listener);

                    if (fData[idxWild].dir === "up") {
                        if (fData[idxWild].count === 2) {
                            symbol.state.setAnimation(0, "land_2x3_up", false);
                            symbol.state.addAnimation(0, "nudge_2x3_up", false);
                            symbol.state.addAnimation(0, "idle_up", false);
                        } else {
                            symbol.state.setAnimation(0, "land_1x3_up", false);
                            symbol.state.addAnimation(0, "nudge_1x3_up", false);
                            symbol.state.addAnimation(0, "idle_up", false);
                        }
                    } else if (fData[idxWild].dir === "down") {
                        if (fData[idxWild].count === 2) {
                            symbol.state.setAnimation(0, "land_2x3_down", false);
                            symbol.state.addAnimation(0, "nudge_2x3_down", false);
                            symbol.state.addAnimation(0, "idle_down", false);
                        } else {
                            symbol.state.setAnimation(0, "land_1x3_down", false);
                            symbol.state.addAnimation(0, "nudge_1x3_down", false);
                            symbol.state.addAnimation(0, "idle_down", false);
                        }
                    }
                    symbol.state.timeScale = timeScale;
                    // take them on top
                    const symbolCont = this.reelSymbolContainers[fData[idxWild].reelNum][fData[idxWild].posNum];
                    if (symbolCont) {
                        this.reelOverlayContainer.addChild(symbolCont);
                    }
                })
            } else {
                return Promise.resolve();
            }
        } else {
            if (idx === 7) {
                animationPromise = new Promise<void>((resolve) => {
                    let listener = {
                        complete: (entry: any) => {
                            if (entry.animation.name.startsWith("land")) {
                                resolve();
                                symbol.state.removeListener(listener);
                                this.hideSymbols(reelNum, 7, "up");
                                if (!isSuperQuickBtnOnGlobal && !isQuickBtnOnGlobal && !isSlamClickedGlobal) {
                                    this.animateMask(spinData.respins[RespinIndex.value].featureData.reelHeightPerReel);
                                }
                            }
                        },
                    };
                    symbol.state.addListener(listener);

                    symbol.state.setAnimation(0, "land_up", false);
                    symbol.state.addAnimation(0, "idle_up", false);
                    symbol.state.timeScale = timeScale;
                    // take them on top
                    const symbolCont = this.reelSymbolContainers[reelNum][idx];
                    if (symbolCont) {
                        this.reelOverlayContainer.addChild(symbolCont);
                    }
                });
            } else {
                return Promise.resolve();
            }
        }
        return animationPromise;
    }

    private async hideSymbols(reelNum: number, wildPosNum: number, dir: string) {
        if (dir === "down") {
            for (let fallingSymPos = wildPosNum + 1; fallingSymPos < SYMBOLS_PER_REEL[reelNum]; fallingSymPos++) {
                this.reelSymbolsMapAfterJump[reelNum][fallingSymPos] = wildPosNum;
                this.reelSymbols[reelNum][fallingSymPos].parent.visible = false;
            }
        } else if (dir === "up") {
            for (let fallingSymPos = wildPosNum - 1; fallingSymPos >= 0; fallingSymPos--) {
                this.reelSymbolsMapAfterJump[reelNum][fallingSymPos] = wildPosNum;
                this.reelSymbols[reelNum][fallingSymPos].parent.visible = false;
            }
        }
    }

    private async reelSpinFun(RespinIndex: number, isNewSpin: boolean, spinStype: string): Promise<void> {

        console.log("reelSpinFun", isNewSpin, spinStype);



        const promises: Promise<void>[] = [];

        // Loop over each reel object in the allReelArray
        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL[reelNum]; posNum++) {
                this.reelSymbolsMapAfterJump[reelNum][posNum] = -1;
            }

        }


        this.allReelArray.forEach((reelObj, index) => {
            // Create a promise that chains multiple moveReel calls based on the index
            const promise = new Promise<void>(async (resolve) => {

                this.playReelSound(index);

                while (!spinData.dataFeatched && !this.isBetDecline) {
                    const dummySymbolId = this.getNextRandomSymbol(reelObj.reelIndex);
                    this.swapTopSymbol(reelObj, dummySymbolId);
                    await this.moveReelStep(reelObj);

                    if (this.isBetDecline) {
                        this.stopAllReelSounds();
                        //await this.moveReelFinal(reelObj, RespinIndex);
                        //this.addReelSymbolsToContainer(index);
                        //resolve();
                        // return;
                    }
                }

                if (!this.isBetDecline) {
                    if (spinData.respins[RespinIndex].featureData?.reelHeightPerReel) {
                        setVisibleSymbols(spinData.respins[RespinIndex].featureData.reelHeightPerReel);
                        if ((isSuperQuickBtnOnGlobal || isQuickBtnOnGlobal ||isSlamClickedGlobal) && this.isWildExist()) {
                            this.animateMask(spinData.respins[RespinIndex].featureData.reelHeightPerReel);
                        }
                    }
                }

                if (!this.isBetDecline) {
                    // if (!this.isMouseMeterActivated) {
                    //     this.activateMouseMeter(spinData.respins[RespinIndex].mice);
                    //     this.isMouseMeterActivated = false;
                    // }

                    if (!this.ismovingReelStepsCounted) {
                        this.getMovingSteps(RespinIndex, isNewSpin);
                        this.ismovingReelStepsCounted = true;
                    }

                    let i = 0;
                    while (i < this.movingSteps[index]) {

                        if ((isSuperQuickBtnOnGlobal || isQuickBtnOnGlobal || isSlamClickedGlobal || this.isBetDecline)) {
                            this.animateMask(spinData.respins[RespinIndex].featureData.reelHeightPerReel, true);
                            break;
                        }

                        const dummySymbolId = this.getNextRandomSymbol(reelObj.reelIndex);
                        this.swapTopSymbol(reelObj, dummySymbolId);
                        await this.moveReelStep(reelObj);
                        i++;
                    }

                }

                await this.moveReelFinal(reelObj, RespinIndex);

                this.stopReelSound(index);

                this.resetSymbolLayers();

                this.addReelSymbolsToContainer(index);
                await this.landingAnimation(index);

                // if (!spinData.isBuyFeatureActive) {
                this.playAnticipation(index);
                // }
                resolve();

            });

            promises.push(promise);

        });

        await Promise.all(promises);
        sound.stop('reels_spinning');

        await this.allReelStop();
        this.resetMask();

        if (this.isBetDecline) { // if bet is decline no need to go further for battleTrigger
            return;
        }

        if (isNewSpin && spinStype === "BASE") {
            Manager.casinoChannelHandler.reportResultDisplay();
        }

        if (spinStype === "BASE" && spinData.respins[RespinIndex].winAmount == 0) {
            // in this case no cat jump is required
        }
        else {
            // await this.catJumpFeature(RespinIndex);
        }


        this.running = false;

    }

    private dummyReelSymbolQueues: number[][] = [];
    private getNextRandomSymbol(reelNum: number): number {
        // Initialize queue if not yet
        if (!this.dummyReelSymbolQueues[reelNum]) {
            this.dummyReelSymbolQueues[reelNum] = [];
        }

        // If queue is empty, refill it
        if (this.dummyReelSymbolQueues[reelNum].length === 0) {
            const reelData = DummyReelSymbol[reelNum];
            const maxStartIndex = reelData.length - SYMBOLS_PER_REEL[reelNum];
            const randomStart = Math.floor(Math.random() * maxStartIndex);
            const newSlice = reelData.slice(randomStart, randomStart + SYMBOLS_PER_REEL[reelNum]);

            this.dummyReelSymbolQueues[reelNum].push(...newSlice);
        }

        // Pop the next symbol from the queue
        const dummyReelSymbol = this.dummyReelSymbolQueues[reelNum].shift();
        return dummyReelSymbol;
    }

    private isWildExist() {
        let symbols = spinData.respins[RespinIndex.value].reelSymbols;
        for (let i = 0; i < symbols.length; i++) {
            for (let j = 0; j < symbols[i].length; j++) {
                if (symbols[i][j] === GameConstants.SILVER_WILD_SYMOL_ID) {
                    return true;
                }
            }
        }
        return false;

    }

    private resetSymbolLayers() {
        // adjust the layering
        this.allReelArray.forEach((reelObj) => {
            reelObj.symbols.forEach((symbol) => {
                reelObj.container.addChild(symbol.view);
            })
        })
        console.log("reel reset after spin")
    }

    public reelSymbolsMapAfterJump: number[][] = SYMBOLS_PER_REEL.map((rowCount) =>
        Array(rowCount).fill(-1)
    );


    public catJumpStage: number[] = Array(REEL_NUMBERS).fill(1);

    // private async fallSymbolsOneByOne(reelNum: number, catPosNum: number, timeScale: number) {

    //     for (let fallingSymPos = catPosNum + 1; fallingSymPos < SYMBOLS_PER_REEL[reelNum]; fallingSymPos++) {

    //         this.reelSymbolsMapAfterJump[reelNum][fallingSymPos] = catPosNum

    //         const upperSymbol = this.reelSymbols[reelNum][fallingSymPos];
    //         upperSymbol.state.setAnimation(0, "fall", false);
    //         upperSymbol.state.timeScale = timeScale;
    //         await new Promise((resolve) => setTimeout(resolve, 200 / timeScale));
    //     }
    // }




    // private catJump(reelNum: number, posNum: number, multiplier: number, timeScale: number): Promise<void> {
    //     return new Promise<void>((resolve) => {
    //         const symbol = this.reelSymbols[reelNum][posNum];

    //         // take them on top
    //         const symbolCont = this.reelSymbolContainers[reelNum][posNum];
    //         if (symbolCont) {
    //             this.reelOverlayContainer.addChild(symbolCont);
    //         }

    //         let listener = {
    //             start: async () => {
    //                 // Trigger "fall" animation for symbols above this one
    //                 if (posNum > 0) {
    //                     await new Promise((resolve) => setTimeout(resolve, 100 / timeScale));
    //                     this.fallSymbolsOneByOne(reelNum, posNum, timeScale);
    //                 }
    //             },
    //             event: (_entry: TrackEntry, event: Event) => {
    //                 if (event.data.name === "slap") {

    //                     reelSpinEmitter.emit('shakeEffect');
    //                     // this.slapMouse(reelNum, multiplier);
    //                 }
    //             },
    //             complete: () => {
    //                 // Switch to idle animation after feature animation finishes
    //                 symbol.state.setAnimation(0, `idle_${posNum + 1}`, true);
    //                 symbol.state.timeScale = 1;
    //                 // Cleanup and resolve
    //                 symbol.state.removeListener(listener);
    //                 resolve();
    //             },
    //         };

    //         // Add listeners BEFORE starting the animation
    //         symbol.state.addListener(listener);

    //         // Set playback speed
    //         symbol.state.timeScale = timeScale;

    //         // Now start the animation (after listener setup)
    //         symbol.state.setAnimation(0, `feature_${posNum + 1}`, false);

    //         this.catJumpStage[reelNum] = posNum + 1;
    //     });
    // }


    //@ts-ignore
    // private async catJumpFeature(RespinIndex: number): Promise<void> {


    //     // initialize initialize
    //     for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
    //         for (let posNum = 0; posNum < SYMBOLS_PER_REEL[reelNum]; posNum++) {
    //             this.reelSymbolsMapAfterJump[reelNum][posNum] = -1;
    //         }

    //         this.catJumpStage[reelNum] = 1;
    //     }

    //     let isCharAnimEventSent = false;

    //     let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

    //     const catMultiplier = spinData.respins[RespinIndex].catMultiplier;

    //     const animationPromises: Promise<void>[] = [];

    //     for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {

    //         for (let posNum = 0; posNum < SYMBOLS_PER_REEL[reelNum]; posNum++) {

    //             const symbolId = this.allReelArray[reelNum].symbols[posNum].id;

    //             if (symbolId == 0 && catMultiplier[reelNum][posNum] > 0) {

    //                 if (!isCharAnimEventSent) {
    //                     isCharAnimEventSent = true;
    //                     // reelSpinEmitter.emit('animateCharacter', 'win_1');
    //                 }

    //                 const animationPromise = this.catJump(reelNum, posNum, catMultiplier[reelNum][posNum], timeScale);
    //                 // sound.play('wild_expand_and_slap', { volume: 1 });
    //                 animationPromises.push(animationPromise);

    //                 await new Promise((resolve) => setTimeout(resolve, 200));

    //             }
    //         }

    //         await Promise.all(animationPromises);
    //     }
    // }

    private stopAnticipationSound(): void {
        this.anticipationInSound?.stop();
        this.anticipationInSound = null;

        this.anticipationLoopSound?.stop();
        this.anticipationLoopSound = null;

        // if (this.resetVolume && currentBackgorundMusic) {
        //     currentBackgorundMusic.volume = currentBackgorundMusicVolume;
        // }
    }

    private stopAnticipation(): void {
        this.stopAnticipationSound();

        for (let i = 0; i < this.anticipation.length; i++) {
            this.anticipation[i].visible = false;
            this.anticipation[i].state.clearTrack(0);
        }
    }



    private playAnticipation(i: number): void {
        if (isSlamClickedGlobal) {
            this.stopAnticipation();
            return;
        }
        // Clear previous visuals & audio
        this.stopAnticipationSound();


        this.anticipation[i].visible = false;
        this.anticipation[i].state.clearTrack(0);
        this.wildAnticipation.visible = false;

        if (!spinData.isBuyFeatureActive) {
            if (i < REEL_NUMBERS - 1 && this.anticipationReels[i + 1] === 1) {

                if (currentBackgorundMusic && !this.resetBackgoundVolume) {
                    currentBackgorundMusic.volume = 0.3;
                    this.resetBackgoundVolume = true;
                }

                this.anticipation[i + 1].visible = true;
                this.anticipation[i + 1].state.setAnimation(0, "anticipation_2", true);


                this.anticipationInSound = sound.play('scatter_anticipation_loop', {
                    loop: true,
                    volume: 1
                }) as IMediaInstance;


            }
        }
        if (i === 3 && this.wildAnticipationReels[4] === 1 && !isSlamClickedGlobal) {
            this.wildAnticipation.visible = true;
            this.anticipationInSound = sound.play('golden_drill_anticipation', {
                loop: true,
                volume: 1
            }) as IMediaInstance;
            this.wildAnticipation.state.setAnimation(0, "animation", true);
        }
    }


    private async moveReelFinal(reelObj: ReelObject, RespinIndex: number): Promise<void> {
        return new Promise(async (resolve) => {
            const reelNum = reelObj.reelIndex;

            let finalReelData: number[];

            if (!this.isBetDecline) {
                finalReelData = spinData.respins[RespinIndex].reelSymbols[reelNum];
            }
            else {
                finalReelData = this.reelSymbolsBeforeSpin[reelNum];
            }

            // console.log("finalReelData", finalReelData);

            for (let i = 0; i < finalReelData.length; i++) {
                const symbolId = finalReelData[finalReelData.length - 1 - i];

                // console.log("finalReelData symbolId", symbolId);

                this.swapTopSymbol(reelObj, symbolId);
                await this.moveReelStep(reelObj);

                if (i == finalReelData.length - 1) {
                    this.reArrangeTheSymbolOrder(reelObj);
                }
            }

            resolve();
        });
    }

    private swapTopSymbol(reelObj: ReelObject, symbolId: number) {
        const topSymbol = reelObj.symbols[SYMBOLS_PER_REEL[reelObj.reelIndex]];
        topSymbol.id = symbolId;
        topSymbol.symbol.texture = getSymbol(symbolId);
    }

    private reArrangeTheSymbolOrder(reelObj: ReelObject) {
        // // Re-add them in correct order (important for rendering layer)
        reelObj.symbols.forEach((s) => {
            reelObj.container.addChild(s.view);
        });
    }


    private async moveReelStep(reelObj: ReelObject): Promise<void> {

        const movetime = isSuperQuickBtnOnGlobal ? 10 : (isQuickBtnOnGlobal ? 20 : 40);

        return new Promise((resolve) => {
            const totalSymbols = reelObj.symbols.length;
            let completed = 0;

            // Move each symbol visually
            reelObj.symbols.forEach((symbol) => {
                const symbolContainer = symbol.view;

                const tween = new Tween(symbolContainer, reelTweenGroup)
                    .to({ y: symbolContainer.y + SYMBOL_HEIGHT }, movetime)
                    .onComplete(() => {
                        reelTweenGroup.remove(tween);
                        completed++;

                        // Once all tweens complete
                        if (completed === totalSymbols) {

                            // Move last symbol visually to top
                            const movedSymbol = reelObj.symbols.pop();
                            if (movedSymbol) {
                                movedSymbol.view.y = - (SYMBOL_HEIGHT / 2);
                                movedSymbol.y = movedSymbol.view.y;
                                reelObj.symbols.unshift(movedSymbol);
                            }

                            // Update symbolIndex and view.y of all symbols
                            reelObj.symbols.forEach((s, i) => {
                                s.symbolIndex = i;
                                s.view.y = i === SYMBOLS_PER_REEL[reelObj.reelIndex]
                                    ? - (SYMBOL_HEIGHT / 2)
                                    : (SYMBOL_HEIGHT / 2) + i * SYMBOL_HEIGHT;
                                s.y = s.view.y;
                            });


                            resolve();
                        }
                    })
                    .start();
            });
        });
    }

    public resetSymbolPositions() {

        this.allReelArray.forEach((reelObj) => {

            reelObj.symbols.forEach((symbol) => {
                const targetPos = symbol.y;
                const symbolContainer = symbol.view;
                symbolContainer.y = targetPos;

            })

        })
    }


    private async allReelStop() {
        if (this.resetBackgoundVolume && currentBackgorundMusic) {
            currentBackgorundMusic.volume = currentBackgorundMusicVolume;
        }

        this.stopAnticipationSound();

        for (let i: number = 0; i < REEL_NUMBERS - 1; i++) {
            this.anticipation[i].visible = false;
        }

        // this.ui.spin.interactive = true;

        // this.running = false;
        console.log("reel spin done");



    }



    // Add other methods as needed
}
